import styled from "styled-components";

export const PageLayout = styled.div`
  display: flex;
  width: 100%;
  min-height: 100vh;
  background-color: #f9fafb;
`;

export const Container = styled.div`
  flex: 1;
  padding: 2rem;
  background-color: #f9fafb;
  font-family: "Inter", sans-serif;
`;

export const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
  margin-bottom: 1.5rem;
`;

export const Title = styled.h1`
  font-size: 30px;
  font-weight: 700;
  color: #111827;
`;

export const Subtitle = styled.p`
  color: #6b7280;
  font-size: 16px;
  margin-top: 20px;
`;

export const AddButton = styled.button`
  background-color: #2563eb;
  color: #fff;
  font-weight: 500;
  border: none;
  display: flex;
  align-items: center;
  gap: 0.4rem;
  padding: 0.65rem 1rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: 0.2s ease;

  &:hover {
    background-color: #1e4ed8;
  }
`;

export const SearchWrapper = styled.div`
  width: 100%;
  position: relative;
  margin-bottom: 1.5rem;

  .icon {
    position: absolute;
    left: 14px;
    top: 50%;
    transform: translateY(-50%);
    color: #9ca3af;
  }
`;

export const SearchInput = styled.input`
  width: 100%;
  height: 45px;
  padding-left: 45px;
  padding-right: 1rem;
  border: 1px solid #d1d5db;
  border-radius: 0.5rem;
  font-size: 0.95rem;
  color: #374151;
  background-color: #fff;

  &::placeholder {
    color: #9ca3af;
  }

  &:focus {
    outline: none;
    border-color: #2563eb;
    box-shadow: 0 0 0 2px rgba(37, 99, 235, 0.12);
  }
`;

export const SortWrapper = styled.div`
  display: flex;
  align-items: center;
  gap: 1rem;
  margin-bottom: 1.2rem;

  label {
    font-size: 0.95rem;
    font-weight: 600;
    color: #374151;
  }

  select {
    padding: 0.45rem 0.8rem;
    border-radius: 0.5rem;
    border: 1px solid #d1d5db;
    font-size: 0.9rem;
    cursor: pointer;
    background: white;
  }
`;

export const Table = styled.table`
  width: 100%;
  border-collapse: collapse;
  background: #fff;
  border-radius: 0.6rem;
  overflow: hidden;
`;

export const TableRow = styled.tr`
  height: 70px;

  &:not(:first-child) {
    border-bottom: 1px solid #e5e7eb;
  }

  &:hover {
    background-color: #f9fafb;
  }
`;

export const TableHeader = styled.th`
  background: #f3f4f6;
  color: #374151;
  font-size: 16px;
  font-weight: 600;
  padding: 1rem;
  text-align: left;
  border-bottom: 1px solid #e5e7eb;
`;

export const TableCell = styled.td`
  padding: 1rem;
  vertical-align: top;
  color: #111827;
  font-size: 0.9rem;
`;

export const HighlightRow = styled.tr`
  cursor: pointer;
  transition: 0.2s ease;

  background: ${(p) =>
    p.highlighted ? "#e8f0ff" : p.selected ? "#f9fafb" : "transparent"};

  border-left: 4px solid
    ${(p) => (p.highlighted ? "#3b82f6" : "transparent")};

  &:hover {
    background-color: ${(p) => (p.highlighted ? "#dce9ff" : "#f9fafb")};
  }

  &:not(:last-child) {
    border-bottom: 1px solid #e5e7eb;
  }
`;

export const StatusBadge = styled.span`
  background-color: ${(props) => props.bgColor};
  color: ${(props) => props.textColor};
  font-size: 0.75rem;
  font-weight: 500;
  padding: 0.35rem 0.75rem;
  border-radius: 1rem;
`;

export const ActionIcons = styled.div`
  display: flex;
  gap: 0.75rem;
  align-items: center;

  svg {
    cursor: pointer;
    transition: 0.2s;
    display: inline-block;

    &:hover {
      opacity: 0.8;
    }
  }
`;

export const EventInfo = styled.div``;

export const EventTitle = styled.div`
  font-weight: 600;
  font-size: 0.95rem;
`;

export const EventSubtitle = styled.div`
  font-size: 0.8rem;
  color: #6b7280;
  display: -webkit-box;
  -webkit-line-clamp: 2;
  -webkit-box-orient: vertical;
  overflow: hidden;
  text-overflow: ellipsis;
`;

export const ModalOverlay = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
  overflow-y: auto;
  padding: 20px 0;
`;

export const ModalContent = styled.div`
  background: #fff;
  border-radius: 12px;
  max-width: 650px;
  width: 92%;
  box-shadow: 0 10px 25px rgba(0, 0, 0, 0.12);
  display: flex;
  flex-direction: column;
  max-height: 80vh;      /* 🔥 controla a altura */
  overflow: hidden;
  position: relative;
`;


export const ModalImageHeader = styled.div`
  width: 100%;
  height: 400px;
  overflow: hidden;
  position: relative;
  background-color: #f3f4f6;

  img {
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  .placeholder {
    height: 100%;
    display: flex;
    justify-content: center;
    align-items: center;
    color: #9ca3af;
    font-style: italic;
    font-weight: 500;
  }
`;
export const ModalCloseButton = styled.button`
  position: absolute;
  top: 12px;
  right: 12px;
  background: rgba(0, 0, 0, 0.5);
  border: none;
  border-radius: 9999px;
  width: 34px;
  height: 34px;
  display: flex;
  align-items: center;
  justify-content: center;
  cursor: pointer;
  color: white;
  transition: 0.2s ease;
  z-index: 10;

  &:hover {
    background: rgba(0, 0, 0, 0.75);
    transform: scale(1.05);
  }
`;

export const ModalSection = styled.div`
  margin-top: 1.5rem;
  padding-top: 1rem;
  border-top: 1px solid #e5e7eb;
`;

export const ModalSectionTitle = styled.h3`
  font-size: 1.1rem;
  font-weight: 600;
  color: #1f2937;
  margin-bottom: 0.75rem;
`;

export const ModalTag = styled.span`
  background-color: #f3e8ff;
  color: #7e22ce;
  font-size: 0.8rem;
  font-weight: 500;
  padding: 4px 10px;
  border-radius: 9999px;
`;

export const ModalInfoItem = styled.div`
  display: flex;
  align-items: center;
  margin-bottom: 0.75rem;
  gap: 1rem;
`;

export const ModalInfoIcon = styled.div`
  padding: 0.5rem;
  border-radius: 50%;
  background-color: ${(props) => props.color}1a;
  color: ${(props) => props.color};
  display: flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
`;

export const ModalInfoText = styled.span`
  font-size: 1rem;
  color: #374151;
  font-weight: 500;
`;

export const ModalParticipation = styled.div`
  background-color: #ecfdf5;
  color: #047857;
  padding: 1rem;
  border-radius: 8px;
  margin-top: 1.5rem;

  ${ModalSectionTitle} {
    color: #065f46;
    margin-bottom: 0.5rem;
  }

  p {
    font-size: 0.9rem;

    strong {
      color: #065f46;
      display: block;
      margin-bottom: 4px;
    }

    span {
      color: #047857;
    }
  }
`;

export const ModalRememberButton = styled.button`
  width: 100%;
  background-color: #2563eb;
  color: #fff;
  font-weight: 600;
  border: none;
  padding: 0.75rem 1rem;
  margin-top: 1.5rem;
  border-radius: 0.5rem;
  cursor: pointer;
  transition: 0.2s ease;
  font-size: 1rem;
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 0.4rem;

  &:hover {
    background-color: #1e4ed8;
  }
`;
